import { useState } from "react";
import LogoSvg from "../svg/LogoSvg";

type LogoProps = {
  src: string | undefined;
  alt: string | undefined;
};

export const Logo = ({ src, alt = "" }: LogoProps) => {
  const [showFallback, setShowFallback] = useState(!src);

  if (showFallback) {
    return <LogoSvg />;
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setShowFallback(true)}
    />
  );
};
